import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import FloatingLabelInput from "./FloatingLabelInput"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import { Multiselect } from "multiselect-react-dropdown"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import Switch from "@material-ui/core/Switch"
import Collapse from "@material-ui/core/Collapse"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import ReactExport from "react-data-export"
import Avatar from "@material-ui/core/Avatar"
import { Lightbox } from "react-modal-image"
import Box from "@material-ui/core/Box"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import { makeStyles } from "@material-ui/core/styles"
import Checkbox from "@material-ui/core/Checkbox"
import Snackbar from "@material-ui/core/Snackbar"
import ReactHTMLTableToExcel from "react-html-table-to-excel"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const useRowStyles = makeStyles({
      root: {
            "& > *": {
                  borderBottom: "unset",
            },
      },
})

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}
const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "blue",
            },
      },
})

class ChangeRequestFinancialPayChecked extends Component {
      cookies = new Cookies()

      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  showPaperDetail: false,
                  archiveDetail: [],
                  orderBy: "request_id",
                  order: "desc",
                  options: [],
                  optionFieldInsurance: [],
                  optionCompany: [{ value: "0", label: "همه شرکت های بیمه" }],
                  optionCity: [{ value: "0", label: "همه شهرها" }],
                  optionState: [{ value: "0", label: "همه استانها" }],
                  selectedFieldInsurance: [],
                  selectedCity: { value: "0", label: "همه شهرها" },
                  selectedState: { value: "0", label: "همه استانها" },
                  optionEmployee: [{ value: "0", label: "همه کارمندان " }],
                  selectedEmployee: { value: "0", label: "همه کارمندان" },
                  optionAgent: [{ value: "0", label: "همه نماینده های بیمه" }],
                  selectedAgent: { value: "0", label: "همه نماینده های بیمه" },
                  selectedComoany: { value: "0", label: "همه شرکت های بیمه" },
                  selectedDayEnd: "",
                  selectedDayStart: "",
                  dataChart: [],
                  mobileUsertFilter: "",
                  requestIdFilter: "",
                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  checkFinancialDocAll: false,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  sumValueDoc: 0,
                  agentNameDoc: "",
                  agentAccBankDoc: "",
                  numRequestDoc: 0,
                  dateDoc: "",
                  numDoc: "",

                  optionModeClearing: [{ value: "0", label: "همه انواع تسویه" }],
                  selectedModeClearing: { value: "0", label: "همه انواع تسویه" },
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getOrder()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getOrder() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            console.log("dsadasdasd")
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {
                                    self.getFieldInsurance()
                                    self.getoptionModeClearingID()

                                    self.getoptionStateID()
                                    self.getoptionCompany()
                                    self.getoptionAgent()
                                    self.getoptionEmployee()

                                    self.hidePaperDetail()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_request")
            fd.append("approvalmode", "checkedfinancial")
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/financialpaying`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionModeClearingID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه انواع تسویه" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({
                                          value: arr.data[k].request_ready_clearing_mode_id,
                                          label: arr.data[k].request_ready_clearing_mode_name,
                                    })
                              }
                              self.setState({ optionModeClearing: State, selectedModeClearing: { value: "0", label: "همه انواع تسویه" } })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }

            var fd = new FormData()
            fd.append("command", "get_clearingmode")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getFieldInsurance() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var i,
                                    temp,
                                    temparray = []

                              self.setState({ optionFieldInsurance: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/financialpaying`)
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Comoany = [{ value: "0", label: "همه شرکت های بیمه" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Comoany.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionComoany: Comoany, selectedComoany: Comoany[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionStateID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه استانها" }]

                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].state_id, label: arr.data[k].state_name })
                              }
                              self.setState({ optionState: State, selectedState: State[0] }, () => {
                                    self.getoptionCityID()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_state")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getoptionCityID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", this.state.selectedState.value)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getoptionAgent = () => {
            const { selectedCity, selectedState, selectedComoany } = this.state
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه نماینده های بیمه" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({
                                          value: arr.data[k].agent_id,
                                          label: arr.data[k].agent_name + " " + arr.data[k].agent_family + "-" + arr.data[k].agent_mobile,
                                          agent_status: arr.data[k].agent_status,
                                          company_id: arr.data[k].company_id,
                                    })
                              }
                              self.setState({ optionAgent: State, selectedAgent: { value: "0", label: "همه نماینده های بیمه" } })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            console.log("aaaaa")
            console.log(selectedState.value)
            console.log(selectedCity.value)
            console.log(selectedComoany.value)
            var fd = new FormData()
            fd.append("command", "get_agent")
            if (selectedState.value !== "0") {
                  fd.append("agent_state_id", selectedState.value)
            } //
            if (selectedCity.value !== "0") {
                  fd.append("agent_city_id", selectedCity.value)
            } //
            if (selectedComoany.value !== "0") {
                  fd.append("agent_company_id", selectedComoany.value)
            } //
            // fd.append('agent_city_id', 'get_agent' );
            //   fd.append('agent_company_id', 'get_agent' );

            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionEmployee = () => {
            const { selectedAgent } = this.state
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه نماینده های بیمه" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({
                                          value: arr.data[k].employee_id,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family,
                                    })
                              }
                              self.setState({ optionEmployee: State, selectedEmployee: { value: "0", label: "همه نماینده های بیمه" } })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            console.log("aaaaa")
            console.log(selectedAgent.value)
            var fd = new FormData()
            fd.append("command", "get_employee_byagent")
            if (selectedAgent.value !== "0") {
                  fd.append("agent_id", selectedAgent.value)
            } //

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }
      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }
      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getOrder()
            })
      }

      handleModeClearing = (selectedModeClearing) => {
            this.setState({ selectedModeClearing: selectedModeClearing }, () => {
                  this.filterList()
            })
      }

      handleSelectRows = (request_id, row) => {
            console.log(row["user_pey_cash"])
            var request_ready = null
            var request_financial_approval = null
            if (row["request_ready"]) {
                  request_ready = row["request_ready"][0]
            }
            if (row["request_financial_approval"]) {
                  request_financial_approval = row["request_financial_approval"][0]
            }
            this.setState({ showPaperDetail: true, archiveDetail: row })
      }

      handleChangeCheckbox = (event, row) => {
            const { requestinfofilter, checkFinancialDocAll } = this.state
            var arraytemp = requestinfofilter
            var i, j
            var temp = true
            for (i = 0; i < arraytemp.length; i++) {
                  if (arraytemp[i].request_id === row.request_id) {
                        var request_i = arraytemp[i]
                        var request_ready_i = request_i["request_ready"][0]
                        console.log("request_ready_i", arraytemp[i].request_id, request_ready_i.request_ready_clearing_id)

                        if (event.target.checked) {
                              for (j = 0; j < arraytemp.length; j++) {
                                    var request_j = arraytemp[j]
                                    var request_ready_j = request_j["request_ready"][0]
                                    console.log(arraytemp[j].checkfinancialdoc)
                                    arraytemp[i].checkfinancialdoc = "1"
                                    if (
                                          (arraytemp[i].agent_id !== arraytemp[j].agent_id &&
                                                arraytemp[j].checkfinancialdoc === "1" &&
                                                request_ready_i.request_ready_clearing_id === "2" &&
                                                request_ready_j.request_ready_clearing_id === "2") ||
                                          (arraytemp[i].request_company_id !== arraytemp[j].request_company_id &&
                                                arraytemp[j].checkfinancialdoc === "1" &&
                                                request_ready_i.request_ready_clearing_id === "3" &&
                                                request_ready_j.request_ready_clearing_id === "3") ||
                                          (request_ready_i.requst_ready_employee_id !== request_ready_j.requst_ready_employee_id &&
                                                arraytemp[j].checkfinancialdoc === "1" &&
                                                request_ready_i.request_ready_clearing_id === "1" &&
                                                request_ready_j.request_ready_clearing_id === "1") ||
                                          (request_ready_i.request_ready_clearing_id !== request_ready_j.request_ready_clearing_id &&
                                                arraytemp[j].checkfinancialdoc === "1")
                                    ) {
                                          console.log(
                                                "request_ready_j",
                                                arraytemp[i].request_company_id,
                                                arraytemp[j].request_company_id,
                                                arraytemp[j].request_id,
                                                request_ready_j.request_ready_clearing_id,
                                                false,
                                                i,
                                                j
                                          )
                                          temp = false
                                    } else {
                                          console.log(
                                                "request_ready_j",
                                                arraytemp[i].request_company_id,
                                                arraytemp[j].request_company_id,
                                                arraytemp[j].request_id,
                                                request_ready_j.request_ready_clearing_id,
                                                true,
                                                i,
                                                j
                                          )
                                    }
                              }
                              if (temp === false) {
                                    arraytemp[i].checkfinancialdoc = "0"
                              }
                        } else {
                              arraytemp[i].checkfinancialdoc = "0"
                        }
                  }
            }

            if (temp) {
                  if (!event.target.checked) {
                        this.setState({ checkFinancialDocAll: false, requestinfofilter: arraytemp }, () => {
                              this.createDoc()
                        })
                  } else {
                        this.setState({ requestinfofilter: arraytemp }, () => {
                              this.createDoc()
                        })
                  }
            } else {
                  this.setState({ snackstr: "لطفا سفارش های یک نماینده مشخص را انتخاب نمایید", showSnack: true, snackMode: "error" }, () => {
                        this.createDoc()
                  })
            }
      }

      handleChangeCheckboxAll = (event) => {
            const { requestinfofilter } = this.state
            var arraytemp = requestinfofilter
            var i, j
            var temp = true
            for (i = 0; i < arraytemp.length; i++) {
                  if (event.target.checked) {
                        for (j = 0; j < arraytemp.length; j++) {
                              arraytemp[i].checkfinancialdoc = "1"
                              if (arraytemp[i].agent_id !== arraytemp[j].agent_id && arraytemp[j].checkfinancialdoc === "1") {
                                    temp = false
                              }
                        }
                  } else {
                        arraytemp[i].checkfinancialdoc = "0"
                  }
            }
            if (temp === false) {
                  for (i = 0; i < arraytemp.length; i++) {
                        arraytemp[i].checkfinancialdoc = "0"
                  }
                  this.setState(
                        {
                              checkFinancialDocAll: false,
                              requestinfofilter: arraytemp,
                              snackstr: "لطفا سفارش های یک نماینده مشخص را انتخاب نمایید",
                              showSnack: true,
                              snackMode: "error",
                        },
                        () => {
                              this.createDoc()
                        }
                  )
            } else {
                  this.setState({ checkFinancialDocAll: event.target.checked, requestinfofilter: arraytemp }, () => {
                        this.createDoc()
                  })
            }
      }
      saveDoc = () => {
            const { requestinfofilter, sumValueDoc, numRequestDoc, numDoc } = this.state
            if (parseInt(numDoc) > 0) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getOrder()
                                    self.setState({
                                          numDoc: "",
                                          numRequestDoc: 0,
                                          sumValueDoc: 0,
                                          agentNameDoc: "",
                                          agentAccBankDoc: "",
                                          dateDoc: "",
                                          snackstr: "سند واریز برای درخواست های انتخاب شده صادر شد",
                                          showSnack: true,
                                          snackMode: "success",
                                    })
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_doc")
                  fd.append("request_financial_doc_price", sumValueDoc)
                  fd.append("request_financial_doc_num", numDoc)
                  fd.append("request_financial_doc_numdoc", numRequestDoc)
                  for (var i = 0; i < requestinfofilter.length; i++) {
                        if (requestinfofilter[i].checkfinancialdoc === "1") {
                              fd.append("array_request_id[]", requestinfofilter[i].request_id)
                        }
                  }
                  xhttp.open("POST", `${constants.BASE_URL}/financialpaying`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا برای صدور سند جدید درخواست  انتخاب کنید", showSnack: true, snackMode: "error" })
            }
      }

      createDoc = () => {
            const { requestinfofilter } = this.state
            var arraytemp = requestinfofilter
            var i,
                  j,
                  sumValueDoc = 0,
                  agentNameDoc = "",
                  agentAccBankDoc = "",
                  numRequestDoc = 0,
                  dateDoc = "",
                  numDoc = "",
                  elementArray,
                  agentId
            var temp = true
            var request_financial_approval = null
            for (i = 0; i < arraytemp.length; i++) {
                  if (arraytemp[i].checkfinancialdoc === "1") {
                        numRequestDoc++
                        elementArray = arraytemp[i]
                        if (elementArray["request_financial_approval"]) {
                              request_financial_approval = elementArray["request_financial_approval"][0]
                              agentNameDoc = arraytemp[i].agent_name + " " + arraytemp[i].agent_family
                              agentAccBankDoc =
                                    arraytemp[i].agent_bankname +
                                    " - شماره حساب:" +
                                    arraytemp[i].agent_banknum +
                                    " - شماره شبا:" +
                                    arraytemp[i].agent_banksheba
                              agentId = arraytemp[i].agent_id
                        }
                        sumValueDoc += parseInt(request_financial_approval["request_financial_approval_price"])
                        console.log(parseInt(request_financial_approval["request_financial_approval_price"]))
                  }
            }
            const jdate = new JDate() // => default to today
            dateDoc = jdate.format("YYYY/MM/DD ")
            if (numRequestDoc > 0) {
                  if (sumValueDoc > 100) {
                        numDoc = jdate.format("YYYYMMDD") + "-" + agentId + "-" + numRequestDoc + "-" + sumValueDoc / 100
                  } else {
                        numDoc = jdate.format("YYYYMMDD") + "-" + agentId + "-" + numRequestDoc + "-" + sumValueDoc
                  }
            }
            this.setState({
                  numDoc: numDoc,
                  numRequestDoc: numRequestDoc,
                  sumValueDoc: sumValueDoc,
                  agentNameDoc: agentNameDoc,
                  agentAccBankDoc: agentAccBankDoc,
                  dateDoc: dateDoc,
            })
      }
      hidePaperDetail = (event) => {
            this.setState({ showPaperDetail: false })
      }

      onSelectOptionFieldInsurance = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedFieldInsurance: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionFieldInsurance = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedFieldInsurance: selectedList }, () => {
                  this.filterList()
            })
      }

      handleState = (selectedState) => {
            this.setState({ selectedState: selectedState, selectedCity: { value: "0", label: "همه شهرها" } }, () => {
                  this.getoptionCityID()
                  this.getoptionAgent()
                  this.filterList()
            })
      }
      handleCity = (selectedCity) => {
            this.setState({ selectedCity: selectedCity }, () => {
                  this.getoptionAgent()
                  this.filterList()
            })
      }
      handleAgent = (selectedAgent) => {
            this.setState({ selectedAgent: selectedAgent }, () => {
                  this.filterList()
                  this.getoptionEmployee()
            })
      }

      handleEmployee = (selectedEmployee) => {
            this.setState({ selectedEmployee: selectedEmployee }, () => {
                  this.filterList()
            })
      }

      handleCompany = (selectedComoany) => {
            this.setState({ selectedComoany: selectedComoany }, () => {
                  this.getoptionAgent()
                  this.filterList()
            })
      }

      handleChangeFilterMobileUser = (event) => {
            this.setState({ mobileUsertFilter: event.target.value }, () => {
                  this.filterList()
            })
      }
      handleChangeFilterRequestId = (event) => {
            this.setState({ requestIdFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const {
                  requestinfos,
                  mobileUsertFilter,
                  requestIdFilter,
                  selectedFieldInsurance,
                  selectedAgent,
                  selectedModeClearing,
                  selectedEmployee,
                  selectedCity,
                  selectedState,
                  selectedDayEnd,
                  selectedDayStart,
            } = this.state
            var timeStampStart = parseInt(
                  Moment(JDate.toGregorian(selectedDayStart.year, selectedDayStart.month, selectedDayStart.day)).format("x"),
                  0
            )
            var timeStampEnd = parseInt(Moment(JDate.toGregorian(selectedDayEnd.year, selectedDayEnd.month, selectedDayEnd.day)).format("x"), 0)

            var i, temparray, temparray2, requst_ready_start_date
            temparray = requestinfos
            temparray2 = []
            console.log(selectedAgent)
            for (i = 0; i < temparray.length; i++) {
                  var request = temparray[i]
                  var request_ready = request["request_ready"][0]
                  requst_ready_start_date = parseInt(Moment(request_ready.requst_ready_start_date, "YYYY-M-D HH:mm:ss").format("x"))
                  if (
                        this.feieldInsuranceExist(temparray[i].fieldinsurance_id, selectedFieldInsurance) &&
                        ((mobileUsertFilter !== "" && temparray[i].user_mobile.includes(mobileUsertFilter)) || mobileUsertFilter === "") &&
                        ((requestIdFilter !== "" && temparray[i].request_id === requestIdFilter) || requestIdFilter === "") &&
                        (requst_ready_start_date > timeStampStart || !timeStampStart) &&
                        (requst_ready_start_date < timeStampEnd || !timeStampEnd) &&
                        (temparray[i].agent_city_id === selectedCity.value || selectedCity.value === "0") &&
                        (temparray[i].agent_state_id === selectedState.value || selectedState.value === "0") &&
                        (temparray[i].agent_id === selectedAgent.value || selectedAgent.value === "0") &&
                        (request_ready.request_ready_clearing_id === selectedModeClearing.value || selectedModeClearing.value === "0") &&
                        (request_ready.requst_ready_employee_id === selectedEmployee.value || selectedEmployee.value === "0")
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      feieldInsuranceExist = (fieldinsurance_id, selectedFieldInsurance) => {
            if (selectedFieldInsurance.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedFieldInsurance.length; j++) {
                        if (fieldinsurance_id === selectedFieldInsurance[j].fieldinsurance_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getOrder()
            })
      }

      clearDeyEnd = (event) => {
            this.setState({ selectedDayEnd: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayEnd = (event) => {
            this.setState({ selectedDayEnd: event }, () => {
                  this.filterList()
            })
      }

      clearDeyStart = (event) => {
            this.setState({ selectedDayStart: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayStart = (event) => {
            this.setState({ selectedDayStart: event }, () => {
                  this.filterList()
            })
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.selectedDayEnd.year
                              ? this.state.selectedDayEnd.year + "/" + this.state.selectedDayEnd.month + "/" + this.state.selectedDayEnd.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.selectedDayStart.year
                              ? this.state.selectedDayStart.year + "/" + this.state.selectedDayStart.month + "/" + this.state.selectedDayStart.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      render() {
            const { classes } = this.props
            const {
                  optionModeClearing,
                  selectedModeClearing,
                  sumValueDoc,
                  agentNameDoc,
                  agentAccBankDoc,
                  numRequestDoc,
                  dateDoc,
                  numDoc,
                  snackMode,
                  snackstr,
                  showSnack,
                  checkFinancialDocAll,
                  selectedComoany,
                  optionComoany,
                  selectedState,
                  selectedCity,
                  optionEmployee,
                  selectedEmployee,
                  optionAgent,
                  selectedAgent,
                  optionCity,
                  optionState,
                  selectedDayEnd,
                  mobileUsertFilter,
                  requestIdFilter,
                  selectedDayStart,
                  order,
                  orderBy,
                  archiveDetail,
                  showPaperDetail,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
            } = this.state
            var request_ready_image_tb = null
            var request_ready_file_tb = null
            var request_ready = null
            var user_pey_detail = null
            var user_pey_detail2 = null
            var request_financial_approval = null

            if (archiveDetail["request_financial_approval"]) {
                  request_financial_approval = archiveDetail["request_financial_approval"][0]
            }

            if (archiveDetail["request_ready"]) {
                  request_ready = archiveDetail["request_ready"][0]
                  if (request_ready) {
                        if (request_ready["request_ready_image_tb"]) {
                              request_ready_image_tb = request_ready["request_ready_image_tb"]
                        }
                        if (request_ready["request_ready_file_tb"]) {
                              request_ready_file_tb = request_ready["request_ready_file_tb"]
                        }
                  }
            }
            if (archiveDetail["user_pey_detail"]) {
                  user_pey_detail = archiveDetail["user_pey_detail"]
            }
            if (archiveDetail["user_pey_detail2"]) {
                  user_pey_detail2 = archiveDetail["user_pey_detail2"]
            }

            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper style={{ padding: "15px", direction: "rtl" }} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع بزرگتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={selectedDayStart}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع کوچکتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={selectedDayEnd}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionFieldInsurance} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionFieldInsurance} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionFieldInsurance} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionFieldInsurance} // Function will trigger on remove event
                                                                              displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب رشته"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedComoany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionComoany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div>
                                                                        <label className="on">استان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"استان"}
                                                                              value={selectedState}
                                                                              onChange={this.handleState}
                                                                              options={optionState}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div>
                                                                        <label className="on">شهر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شهر"}
                                                                              value={selectedCity}
                                                                              onChange={this.handleCity}
                                                                              options={optionCity}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={4}>
                                                                  <div>
                                                                        <label className="on">نماینده</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نماینده"}
                                                                              value={selectedAgent}
                                                                              onChange={this.handleAgent}
                                                                              options={optionAgent}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={4}>
                                                                  <div>
                                                                        <label className="on">کارمند</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کارمند"}
                                                                              value={selectedEmployee}
                                                                              onChange={this.handleEmployee}
                                                                              options={optionEmployee}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12} sm={4}>
                                                                  <div>
                                                                        <label className="on">نوع تسویه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع تسویه"}
                                                                              value={selectedModeClearing}
                                                                              onChange={this.handleModeClearing}
                                                                              options={optionModeClearing}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="همراه کاربر"
                                                                        value={mobileUsertFilter}
                                                                        handleInputt={this.handleChangeFilterMobileUser}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12} sm={2}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره سفارش"
                                                                        value={requestIdFilter}
                                                                        handleInputt={this.handleChangeFilterRequestId}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={2}></Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}></Grid>

                                    <Grid item xs={12}>
                                          <Collapse in={showPaperDetail}>
                                                <Container component="main" maxWidth="lg">
                                                      <Paper elevation={4} className={classes.root}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"شماره درخواست: " + archiveDetail["request_id"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={8} sm={4}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"رشته بیمه : " + archiveDetail["request_fieldinsurance_fa"]}
                                                                                    <img
                                                                                          alt=""
                                                                                          style={{ height: "30px", width: "atuo" }}
                                                                                          src={archiveDetail["fieldinsurance_logo_url"]}
                                                                                    />
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={4}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"شرکت  : " + archiveDetail["company_name"]}
                                                                                    <img
                                                                                          alt=""
                                                                                          style={{ height: "30px", width: "atuo" }}
                                                                                          src={archiveDetail["company_logo_url"]}
                                                                                    />
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={12} sm={6}>
                                                                                    {request_ready_image_tb ? (
                                                                                          <TableContainer component={Paper}>
                                                                                                <Table
                                                                                                      className={classes.table}
                                                                                                      aria-label="simple table"
                                                                                                >
                                                                                                      <TableHead>
                                                                                                            <TableRow>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 60 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        نام عکس
                                                                                                                  </TableCell>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 100 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        توضیحات
                                                                                                                  </TableCell>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 30 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        عکس{" "}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      </TableHead>
                                                                                                      <TableBody>
                                                                                                            {request_ready_image_tb.map((row) => {
                                                                                                                  return (
                                                                                                                        <TableRow
                                                                                                                              key={row.image_name}
                                                                                                                        >
                                                                                                                              <TableCell align="center">
                                                                                                                                    {" "}
                                                                                                                                    {row.image_name}
                                                                                                                              </TableCell>
                                                                                                                              <TableCell align="center">
                                                                                                                                    {row.image_desc}
                                                                                                                              </TableCell>

                                                                                                                              <TableCell align="center">
                                                                                                                                    <div
                                                                                                                                          style={{
                                                                                                                                                width:
                                                                                                                                                      "100%",
                                                                                                                                                textAlign:
                                                                                                                                                      "center",
                                                                                                                                          }}
                                                                                                                                    >
                                                                                                                                          <Avatar
                                                                                                                                                variant="rounded"
                                                                                                                                                alt="Remy Sharp"
                                                                                                                                                src={
                                                                                                                                                      row.image_tumb_url
                                                                                                                                                }
                                                                                                                                                onClick={() => {
                                                                                                                                                      this.setImageModel(
                                                                                                                                                            row.image_tumb_url,
                                                                                                                                                            row.image_url,
                                                                                                                                                            row.image_name
                                                                                                                                                      )
                                                                                                                                                }}
                                                                                                                                          />
                                                                                                                                    </div>
                                                                                                                              </TableCell>
                                                                                                                        </TableRow>
                                                                                                                  )
                                                                                                            })}
                                                                                                      </TableBody>
                                                                                                </Table>
                                                                                          </TableContainer>
                                                                                    ) : null}
                                                                              </Grid>
                                                                              <Grid item xs={12} sm={6}>
                                                                                    {request_ready_file_tb ? (
                                                                                          <TableContainer component={Paper}>
                                                                                                <Table
                                                                                                      className={classes.table}
                                                                                                      aria-label="simple table"
                                                                                                >
                                                                                                      <TableHead>
                                                                                                            <TableRow>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 100 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        توضیحات
                                                                                                                  </TableCell>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 30 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        لینک دانلود{" "}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      </TableHead>
                                                                                                      <TableBody>
                                                                                                            {request_ready_file_tb.map((row) => {
                                                                                                                  return (
                                                                                                                        <TableRow
                                                                                                                              key={
                                                                                                                                    row.request_file_desc
                                                                                                                              }
                                                                                                                        >
                                                                                                                              <TableCell align="center">
                                                                                                                                    {" "}
                                                                                                                                    {
                                                                                                                                          row.request_file_desc
                                                                                                                                    }
                                                                                                                              </TableCell>

                                                                                                                              <TableCell align="center">
                                                                                                                                    <a
                                                                                                                                          href={
                                                                                                                                                row.request_file_url
                                                                                                                                          }
                                                                                                                                    >
                                                                                                                                          دانلود
                                                                                                                                    </a>
                                                                                                                              </TableCell>
                                                                                                                        </TableRow>
                                                                                                                  )
                                                                                                            })}
                                                                                                      </TableBody>
                                                                                                </Table>
                                                                                          </TableContainer>
                                                                                    ) : null}
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"مشخصات کاربر: " +
                                                                                          archiveDetail["user_name"] +
                                                                                          " " +
                                                                                          archiveDetail["user_family"] +
                                                                                          " -  شماره همراه : " +
                                                                                          archiveDetail["user_mobile"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"مشخصات نماینده: " +
                                                                                          archiveDetail["agent_name"] +
                                                                                          " " +
                                                                                          archiveDetail["agent_family"] +
                                                                                          " -  شماره همراه : " +
                                                                                          archiveDetail["agent_mobile"] +
                                                                                          " - کد : " +
                                                                                          archiveDetail["agent_code"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"استان : " +
                                                                                          archiveDetail["agent_state_name"] +
                                                                                          "   - شهرستان:  " +
                                                                                          archiveDetail["agent_city_name"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  {request_ready ? (
                                                                        <Grid item xs={12}>
                                                                              <Grid container spacing={3}>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"شماره بیمه نامه:" +
                                                                                                      request_ready["requst_ready_num_ins"]}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"قیمت اعلام شده نماینده:"}
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={request_ready["requst_ready_end_price"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography variant="h7">
                                                                                                {"تاریخ شروع : "}
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_ready[
                                                                                                                              "requst_ready_start_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD ")}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography variant="h7">
                                                                                                {"تاریخ پایان: "}
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_ready[
                                                                                                                              "requst_ready_end_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD ")}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                              </Grid>
                                                                        </Grid>
                                                                  ) : null}
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Typography align="center" variant="h6">
                                                                              {archiveDetail["user_pey_amount"] === null ||
                                                                              archiveDetail["user_pey_amount"] === ""
                                                                                    ? "مبلغ پرداخت شده : 0 ریال"
                                                                                    : "مبلغ پرداخت شده :  "}
                                                                              {archiveDetail["user_pey_amount"] === null ||
                                                                              archiveDetail["user_pey_amount"] === "" ? null : (
                                                                                    <NumberFormat
                                                                                          displayType={"text"}
                                                                                          value={archiveDetail["user_pey_amount"]}
                                                                                          thousandSeparator={true}
                                                                                          prefix={" ریال"}
                                                                                    />
                                                                              )}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h6">
                                                                              {archiveDetail["user_pey_cash"] === null ||
                                                                              archiveDetail["user_pey_cash"] === ""
                                                                                    ? "مبلغ نقدی پرداخت شده : 0 ریال"
                                                                                    : "مبلغ نقدی پرداخت شده :  "}
                                                                              {archiveDetail["user_pey_cash"] === null ||
                                                                              archiveDetail["user_pey_cash"] === "" ? null : (
                                                                                    <NumberFormat
                                                                                          displayType={"text"}
                                                                                          value={archiveDetail["user_pey_cash"]}
                                                                                          thousandSeparator={true}
                                                                                          prefix={" ریال"}
                                                                                    />
                                                                              )}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h6">
                                                                              {archiveDetail["user_pey_instalment"] === null ||
                                                                              archiveDetail["user_pey_instalment"] === ""
                                                                                    ? "مبلغ اقساط پرداخت شده : 0 ریال"
                                                                                    : "مبلغ اقساط پرداخت شده :  "}
                                                                              {archiveDetail["user_pey_instalment"] === null ||
                                                                              archiveDetail["user_pey_instalment"] === "" ? null : (
                                                                                    <NumberFormat
                                                                                          displayType={"text"}
                                                                                          value={archiveDetail["user_pey_instalment"]}
                                                                                          thousandSeparator={true}
                                                                                          prefix={" ریال"}
                                                                                    />
                                                                              )}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {user_pey_detail2 ? (
                                                                              <TableContainer component={Paper}>
                                                                                    <Table className={classes.table} aria-label="simple table">
                                                                                          <TableHead>
                                                                                                <TableRow>
                                                                                                      <TableCell align="center">
                                                                                                            {" "}
                                                                                                            مبلغ پرداخت شده
                                                                                                      </TableCell>
                                                                                                      <TableCell align="center">توضیحات</TableCell>
                                                                                                </TableRow>
                                                                                          </TableHead>
                                                                                          <TableBody>
                                                                                                {user_pey_detail2.map((row) => (
                                                                                                      <TableRow key={row.user_pey_amount}>
                                                                                                            <TableCell align="center">
                                                                                                                  <NumberFormat
                                                                                                                        displayType={"text"}
                                                                                                                        value={row.user_pey_amount}
                                                                                                                        thousandSeparator={true}
                                                                                                                        prefix={" ریال"}
                                                                                                                  />
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                  {row.user_pey_desc}
                                                                                                            </TableCell>
                                                                                                      </TableRow>
                                                                                                ))}
                                                                                          </TableBody>
                                                                                    </Table>
                                                                              </TableContainer>
                                                                        ) : null}
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {user_pey_detail ? (
                                                                              <TableContainer component={Paper}>
                                                                                    <Table className={classes.table} aria-label="simple table">
                                                                                          <TableHead>
                                                                                                <TableRow>
                                                                                                      <TableCell align="center">
                                                                                                            {" "}
                                                                                                            مبلغ پرداخت شده
                                                                                                      </TableCell>
                                                                                                      <TableCell align="center">توضیحات</TableCell>
                                                                                                      <TableCell align="center">تصویر </TableCell>
                                                                                                      <TableCell align="center">تاریخ</TableCell>
                                                                                                      <TableCell align="center">شماره چک</TableCell>
                                                                                                </TableRow>
                                                                                          </TableHead>
                                                                                          <TableBody>
                                                                                                {user_pey_detail.map((row) => {
                                                                                                      return (
                                                                                                            <TableRow key={row.user_pey_amount}>
                                                                                                                  <TableCell align="center">
                                                                                                                        <NumberFormat
                                                                                                                              displayType={"text"}
                                                                                                                              value={
                                                                                                                                    row.user_pey_amount
                                                                                                                              }
                                                                                                                              thousandSeparator={true}
                                                                                                                              prefix={" ریال"}
                                                                                                                        />
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.user_pey_desc}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        <Avatar
                                                                                                                              variant="rounded"
                                                                                                                              alt="Remy Sharp"
                                                                                                                              src={
                                                                                                                                    row.user_pey_image_turl
                                                                                                                              }
                                                                                                                              onClick={() => {
                                                                                                                                    this.setImageModel(
                                                                                                                                          row.user_pey_image_turl,
                                                                                                                                          row.user_pey_image_url,
                                                                                                                                          "عکس چک های سفارش "
                                                                                                                                    )
                                                                                                                              }}
                                                                                                                        />
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.instalment_check_date}{" "}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.instalment_check_num}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      )
                                                                                                })}
                                                                                          </TableBody>
                                                                                    </Table>
                                                                              </TableContainer>
                                                                        ) : null}
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            </Grid>

                                                            <Grid container spacing={3}>
                                                                  {request_financial_approval ? (
                                                                        <Grid item xs={12}>
                                                                              <Grid container spacing={3}>
                                                                                    <Grid item xs={12}>
                                                                                          <Typography variant="h6">
                                                                                                {"تایید مالی بیمه نامه"}
                                                                                          </Typography>
                                                                                    </Grid>

                                                                                    <Grid item xs={3}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"قیمت تایید شد:  "}
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={
                                                                                                            request_financial_approval[
                                                                                                                  "request_financial_approval_price"
                                                                                                            ]
                                                                                                      }
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"اختلاف قیمت:  "}
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={
                                                                                                            request_financial_approval[
                                                                                                                  "request_financial_approval_difference_price"
                                                                                                            ]
                                                                                                      }
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={6}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"توضیحات:  "}
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={
                                                                                                            request_financial_approval[
                                                                                                                  "request_financial_approval_desc"
                                                                                                            ]
                                                                                                      }
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </Typography>
                                                                                    </Grid>

                                                                                    <Grid item xs={4}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"نام کارمند :" +
                                                                                                      request_financial_approval["employee_name"] +
                                                                                                      " " +
                                                                                                      request_financial_approval["employee_family"]}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={4}>
                                                                                          <Typography variant="h7">
                                                                                                {"تاریخ بررسی: "}
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_financial_approval[
                                                                                                                              "request_financial_approval_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            request_financial_approval[
                                                                                                                  "request_financial_approval_date"
                                                                                                            ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                              </Grid>
                                                                        </Grid>
                                                                  ) : null}

                                                                  <Grid item xs={12}>
                                                                        <div style={{ width: "100%", textAlign: "left" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.hidePaperDetail}
                                                                              >
                                                                                    {"بستن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Paper>
                                                </Container>
                                          </Collapse>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={4}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"تعداد درخواست های سند:  " + numRequestDoc}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره سند:  " + numDoc}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"جمع مبلغ سند:  "}
                                                                        <NumberFormat
                                                                              displayType={"text"}
                                                                              value={sumValueDoc}
                                                                              thousandSeparator={true}
                                                                              prefix={" ریال"}
                                                                        />
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"نام نماینده:  " + agentNameDoc}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={5}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره حساب نماینده:  " + agentAccBankDoc}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"تاریخ سند:  " + dateDoc}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <div style={{ width: "100%", textAlign: "left" }}>
                                                                        <Button variant="outlined" color="primary" onClick={this.saveDoc}>
                                                                              {"ثبت سند"}
                                                                        </Button>
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ExcelFile
                                                            element={
                                                                  <Button variant="outlined" color="primary">
                                                                        {" "}
                                                                        {"اکسل "}
                                                                  </Button>
                                                            }
                                                      >
                                                            <ExcelSheet data={requestinfofilter} name="نمایندگان">
                                                                  <ExcelColumn label="آی دی سفارش" value="request_id" />
                                                                  <ExcelColumn label="شرکت" value="company_name" />
                                                                  <ExcelColumn label="رشته بیمه ای" value="request_fieldinsurance_fa" />
                                                                  <ExcelColumn label="توضیحات" value="request_description" />
                                                                  <ExcelColumn label="اخرین وضعیت" value="request_last_state_name" />
                                                                  <ExcelColumn label="مبلغ پرداخت شده" value="user_pey_amount" />
                                                                  <ExcelColumn label="مبلغ نقدی" value="user_pey_cash" />
                                                                  <ExcelColumn label="نام کاربر" value="user_name" />
                                                                  <ExcelColumn label="نام خانوادگی کاربر" value="user_family" />
                                                                  <ExcelColumn label="همراه کاربر " value="user_mobile" />
                                                                  <ExcelColumn label="آی دی" value="agent_id" />
                                                                  <ExcelColumn label="جنسیت" value="agent_gender" />
                                                                  <ExcelColumn label="نام" value="agent_name" />
                                                                  <ExcelColumn label="نام خانوادگی" value="agent_family" />
                                                                  <ExcelColumn label="شماره همراه" value="agent_mobile" />
                                                                  <ExcelColumn label="تلفن دفتر" value="agent_tell" />
                                                                  <ExcelColumn label="ایمیل" value="agent_email" />
                                                                  <ExcelColumn label="تلفن ضروری" value="agent_required_phone" />
                                                                  <ExcelColumn label="استان " value="agent_state_name" />
                                                                  <ExcelColumn label="شهر " value="agent_city_name" />
                                                                  <ExcelColumn label="نام محله" value="agent_sector_name" />
                                                                  <ExcelColumn label="آدرس" value="agent_address" />
                                                                  <ExcelColumn label="نام بانک" value="agent_bankname" />
                                                                  <ExcelColumn label="شماره حساب" value="agent_banknum" />
                                                                  <ExcelColumn label="شماره شبا" value="agent_banksheba" />
                                                                  <ExcelColumn label="شرکت بیمه" value="agent_company_name" />
                                                                  <ExcelColumn label="کد نمایندگی" value="agent_code" />
                                                            </ExcelSheet>
                                                      </ExcelFile>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />
                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"request_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 30 }}
                                                                                    sortDirection={orderBy === "request_id" ? order : false}
                                                                              >
                                                                                    {"شماره"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_id"}
                                                                                          direction={orderBy === "request_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_company_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_company_id"}
                                                                                          direction={orderBy === "request_company_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_company_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"رشته بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_fieldinsurance_fa"}
                                                                                          direction={
                                                                                                orderBy === "request_fieldinsurance_fa"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_state_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مشخصات نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_code"}
                                                                                          direction={orderBy === "agent_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_state_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"کارمند صدور"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_code"}
                                                                                          direction={orderBy === "agent_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_ready_clearing_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نوع تسویه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_ready_clearing_id"}
                                                                                          direction={
                                                                                                orderBy === "request_ready_clearing_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_ready_clearing_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_city_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ نقدی پرداخت شده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_pey_cash"}
                                                                                          direction={orderBy === "user_pey_cash" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_pey_cash")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ تایید شده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ شروع"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell></TableCell>

                                                                              <TableCell>
                                                                                    <Checkbox
                                                                                          checked={checkFinancialDocAll}
                                                                                          size="medium"
                                                                                          onChange={(e) => {
                                                                                                this.handleChangeCheckboxAll(e)
                                                                                          }}
                                                                                          inputProps={{ "aria-label": "checkbox with small size" }}
                                                                                    />
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              return <Row key={row.name} row={row} self={this} />
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>

                                          {this.state.openImageBox && (
                                                <Lightbox
                                                      medium={urlToLargeImageFile}
                                                      large={urlToHugeImageFile}
                                                      alt={descImageFile}
                                                      onClose={this.closeLightbox}
                                                      showRotate={true}
                                                      hideZoom={false}
                                                />
                                          )}
                                    </Grid>
                              </Grid>

                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                        </div>
                  )
            }
      }
}

function Row(props) {
      const { row, self } = props
      const [open, setOpen] = React.useState(false)
      const classes = useRowStyles()
      var request_ready
      var request_financial_approval
      if (row["request_ready"]) {
            request_ready = row["request_ready"][0]
      }
      if (row["request_financial_approval"]) {
            request_financial_approval = row["request_financial_approval"][0]
      }
      return (
            <React.Fragment>
                  <TableRow hover role="checkbox" tabIndex={-1} key={row["request_id"]} value={row}>
                        <TableCell key={"request_id"} align={"center"}>
                              {row["request_id"]}
                        </TableCell>

                        <TableCell key={"request_company_id"} align={"center"}>
                              <img alt="" style={{ height: "30px", width: "atuo" }} src={row["company_logo_url"]} />

                              {row["company_name"]}
                        </TableCell>

                        <TableCell key={"request_fieldinsurance_fa"} align={"center"}>
                              <img alt="" style={{ height: "30px", width: "atuo" }} src={row["fieldinsurance_logo_url"]} />

                              {row["request_fieldinsurance_fa"]}
                        </TableCell>

                        <TableCell key={"agent_state_name"} align={"center"}>
                              {row["agent_name"] + " " + row["agent_family"] + " - کد : " + row["agent_code"]}
                              <br />
                              {"شماره همراه : " + row["agent_mobile"]}
                        </TableCell>

                        <TableCell key={"employee_name"} align={"center"}>
                              {request_ready["employee_name"] ? request_ready["employee_name"] + " " + request_ready["employee_family"] : ""}
                        </TableCell>

                        <TableCell key={"request_ready_clearing_mode_name"} align={"center"}>
                              {request_ready["request_ready_clearing_mode_name"]}
                        </TableCell>

                        <TableCell key={"user_pey_cash"} align={"center"}>
                              {<NumberFormat displayType={"text"} value={row["user_pey_cash"]} thousandSeparator={true} prefix={" ریال"} />}
                        </TableCell>

                        <TableCell key={"user_mobile"} align={"center"}>
                              {
                                    <NumberFormat
                                          displayType={"text"}
                                          value={request_financial_approval["request_financial_approval_price"]}
                                          thousandSeparator={true}
                                          prefix={" ریال"}
                                    />
                              }
                        </TableCell>

                        <TableCell key={"user_mobile"} align={"center"}>
                              {new JDate(
                                    new Date(parseInt(Moment(request_ready["requst_ready_start_date"], "YYYY-M-D HH:mm:ss").format("x")))
                              ).format("YYYY/MM/DD ")}
                        </TableCell>

                        <TableCell>
                              {
                                    <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={(e) => {
                                                self.handleSelectRows(e, row)
                                          }}
                                    >
                                          جزئیات
                                    </Button>
                              }
                              <br />
                              <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                              </IconButton>
                        </TableCell>
                        <TableCell>
                              <Checkbox
                                    checked={row["checkfinancialdoc"] === "0" ? false : true}
                                    onChange={(e) => {
                                          self.handleChangeCheckbox(e, row)
                                    }}
                                    size="medium"
                                    inputProps={{ "aria-label": "checkbox with small size" }}
                              />
                        </TableCell>
                  </TableRow>

                  <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                              <Collapse in={open} timeout="auto" unmountOnExit>
                                    <Box margin={1}>
                                          <Table size="small" aria-label="purchases">
                                                <TableHead>
                                                      <TableRow>
                                                            <TableCell>{" کل حق بیمه دریافتی"} </TableCell>
                                                            <TableCell>{"مبلغ اقساط پرداخت شده"}</TableCell>
                                                            <TableCell>{"قیمت اعلام شده نماینده"} </TableCell>
                                                            <TableCell>{"اختلاف قیمت"}</TableCell>
                                                      </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                      <TableRow>
                                                            <TableCell>
                                                                  {
                                                                        <NumberFormat
                                                                              displayType={"text"}
                                                                              value={row["user_pey_amount"]}
                                                                              thousandSeparator={true}
                                                                              prefix={" ریال"}
                                                                        />
                                                                  }
                                                            </TableCell>

                                                            <TableCell>
                                                                  {
                                                                        <NumberFormat
                                                                              displayType={"text"}
                                                                              value={row["user_pey_instalment"]}
                                                                              thousandSeparator={true}
                                                                              prefix={" ریال"}
                                                                        />
                                                                  }
                                                            </TableCell>
                                                            <TableCell>
                                                                  {
                                                                        <NumberFormat
                                                                              displayType={"text"}
                                                                              value={request_ready["requst_ready_end_price"]}
                                                                              thousandSeparator={true}
                                                                              prefix={" ریال"}
                                                                        />
                                                                  }
                                                            </TableCell>
                                                            <TableCell>
                                                                  {
                                                                        <NumberFormat
                                                                              displayType={"text"}
                                                                              value={request_ready["requst_ready_end_price"] - row["user_pey_amount"]}
                                                                              thousandSeparator={true}
                                                                              prefix={" ریال"}
                                                                        />
                                                                  }
                                                            </TableCell>
                                                      </TableRow>
                                                </TableBody>
                                          </Table>
                                    </Box>
                              </Collapse>
                        </TableCell>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
                              <Collapse in={open} timeout="auto" unmountOnExit>
                                    <Box margin={1}>
                                          <Table size="small" aria-label="purchases">
                                                <TableHead>
                                                      <TableRow>
                                                            <TableCell>{"تاریخ بررسی"}</TableCell>
                                                            <TableCell>{"نام کارمند"}</TableCell>
                                                      </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                      <TableRow>
                                                            <TableCell component="th" scope="row">
                                                                  {new JDate(
                                                                        new Date(
                                                                              parseInt(
                                                                                    Moment(
                                                                                          request_financial_approval[
                                                                                                "request_financial_approval_date"
                                                                                          ],
                                                                                          "YYYY-M-D HH:mm:ss"
                                                                                    ).format("x")
                                                                              )
                                                                        )
                                                                  ).format("YYYY/MM/DD") +
                                                                        " " +
                                                                        Moment(
                                                                              request_financial_approval["request_financial_approval_date"],
                                                                              "YYYY-M-D HH:mm:ss"
                                                                        ).format("HH:mm:ss")}
                                                            </TableCell>
                                                            <TableCell>
                                                                  {request_financial_approval["employee_name"] +
                                                                        " " +
                                                                        request_financial_approval["employee_family"]}
                                                            </TableCell>
                                                      </TableRow>
                                                </TableBody>
                                          </Table>
                                    </Box>
                              </Collapse>
                        </TableCell>
                  </TableRow>
            </React.Fragment>
      )
}

export default withStyles(styles)(ChangeRequestFinancialPayChecked)
